/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentEventsRequest {
    getFixupPrototypeFunction() { return BillingCommitmentEventsRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentEventsRequest>): BillingCommitmentEventsRequest {
        let obj = Object.assign(new BillingCommitmentEventsRequest(), model);
        BillingCommitmentEventsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentEventsRequest>): BillingCommitmentEventsRequest {
        if (!model) return null;
        return BillingCommitmentEventsRequest.newInstance(<BillingCommitmentEventsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentEventsRequest) {
        if (!obj) return;

        models.BillingCommitmentEventsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentEventsRequest): boolean {
        Object.setPrototypeOf(obj, BillingCommitmentEventsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_id: string;

    /**
     * Start Date of Billing commitment
     */
    start_date: Date;

    /**
     * End Date of Billing commitment
     */
    end_date: Date;

}
